import React from "react";
import fetcher from '../../fetcher/fetch';


export default function StoreFrontContainer({config, token, lang, ...rest}) {
    /**
     * TODO : Implement the storefront component
     * This component will need to fetch cataglog data from the API in parameters
     * and display products, categories, search bar, filters, cart, etc.
     * It will also need to handle user interactions like adding to cart,
     * filtering products, searching, and proceeding to checkout.
     * 
     * WARNING : Do not forget to split all subcomponents into smaller components
     * for better maintainability and readability.
     */

    const [rateCatalog, setRateCatalog] = React.useState(null); // eslint-disable-line no-unused-vars
    const [loadingRates, setLoadingRates] = React.useState(true);

    const [dateCatalog, setDateCatalog] = React.useState(null); // eslint-disable-line no-unused-vars
    const [loadingDate, setLoadingDate] = React.useState(true);

    const [sessionCatalog, setSessionCatalog] = React.useState(null); // eslint-disable-line no-unused-vars
    const [loadingSession, setLoadingSession] = React.useState(false);


    React.useEffect(() => {
        let params = {};
        params.headers = params.headers || {};
        params.headers['Authorization'] = `Bearer ${token}`;
        params.headers['Accept-Language'] = lang;

        // Call for the rates catalog
        fetcher.get(`${config.storefront.catalog_api}/rates`, params)
            .then(data => {
                setRateCatalog(data);
                setLoadingRates(false);
            })
            .catch(error => {
                console.error("Error fetching catalog data:", error);
            }); 
        
        // Call for the date catalog
        fetcher.get(`${config.storefront.catalog_api}/dates`, params)
            .then(data => {
                setDateCatalog(data);
                setLoadingDate(false);
            })
            .catch(error => {
                console.error("Error fetching catalog data:", error);
            });
            
    }, [config.apiUrl, fetcher, token, lang]);

    const onSelectDate = React.useCallback((dateId) => { // eslint-disable-line no-unused-vars
        // When a date is selected, fetch the sessions for that date
        // Warning : Do not forget to set loadingSession to true before fetching

        let params = {};
        params.headers = params.headers || {};
        params.headers['Authorization'] = `Bearer ${token}`;
        params.headers['Accept-Language'] = lang;

        // Call for the session catalog based on selected date
        fetcher.get(`${config.storefront.catalog_api}/${dateId}sessions`, params)
            .then(data => {
                setSessionCatalog(data);
                setLoadingSession(false);
            })
            .catch(error => {
                console.error("Error fetching session data:", error);
            });
    }, [config.apiUrl, fetcher, token, lang]);

    if (loadingRates || loadingDate || loadingSession) {
        return <div>Loading storefront...</div>;
    }
    
    return (
        <div >
            Soon this component will bring us to the future
        </div>
    );
}
